import TypeAheadCoordinatorComponent from '@intercom/embercom-composer/components/type-ahead-coordinator';
export default TypeAheadCoordinatorComponent;
